import { css } from '@microsoft/fast-element';
import { FlexMediaQueriesEnum } from '../flex-layout.types';
export const flexLayoutRWDStyles = (breakPoint) => {
    const bp = breakPoint ? `-${breakPoint}` : ``;
    return css `
    ${bp && `@media only screen and ${FlexMediaQueriesEnum[breakPoint]} {`}
    :host(.spacing${bp}-1x) slot {
      gap: calc(var(--design-unit) * 2px);
    }

    :host(.spacing${bp}-2x) slot {
      gap: calc(var(--design-unit) * 4px);
    }

    :host(.spacing${bp}-3x) slot {
      gap: calc(var(--design-unit) * 6px);
    }

    :host(.spacing${bp}-4x) slot {
      gap: calc(var(--design-unit) * 8px);
    }

    :host(.spacing${bp}-5x) slot {
      gap: calc(var(--design-unit) * 10px);
    }

    :host(.spacing${bp}-6x) slot {
      gap: calc(var(--design-unit) * 12px);
    }

    :host(.flex${bp}-column) slot {
      flex-direction: column;
    }

    :host(.flex${bp}-column-reverse) slot {
      flex-direction: column-reverse;
    }

    :host(.flex${bp}-row) slot {
      flex-direction: row;
    }

    :host(.flex${bp}-row-reverse) slot {
      flex-direction: row-reverse;
    }

    :host(.flex${bp}-wrap) slot {
      flex-wrap: wrap;
    }

    :host(.flex${bp}-wrap-reverse) slot {
      flex-wrap: wrap-reverse;
    }

    :host(.justify${bp}-start) slot {
      justify-content: flex-start;
    }

    :host(.justify${bp}-end) slot {
      justify-content: flex-end;
    }

    :host(.justify${bp}-center) slot {
      justify-content: center;
    }

    :host(.justify${bp}-between) slot {
      justify-content: space-between;
    }

    :host(.justify${bp}-around) slot {
      justify-content: space-around;
    }

    :host(.justify${bp}-evenly) slot {
      justify-content: space-evenly;
    }

    :host(.items${bp}-start) slot {
      align-items: flex-start;
    }

    :host(.items${bp}-end) slot {
      align-items: flex-end;
    }

    :host(.items${bp}-center) slot {
      align-items: center;
    }

    :host(.items${bp}-stretch) slot {
      align-items: stretch;
    }

    :host(.items${bp}-baseline) slot {
      align-items: baseline;
    }

    :host(.content${bp}-start) slot {
      align-content: flex-start;
    }

    :host(.content${bp}-end) slot {
      align-content: flex-end;
    }

    :host(.content${bp}-center) slot {
      align-content: center;
    }

    :host(.content${bp}-between) slot {
      align-content: space-between;
    }

    :host(.content${bp}-around) slot {
      align-content: space-around;
    }

    :host(.content${bp}-evenly) slot {
      align-content: space-evenly;
    }
    ${bp && `}`}
  `;
};
